import { isWantAction } from '../helpers'
import makeBaseItemsReducer from './base'
import itemsWantedReducer from './wanted'
import itemsInterestReducer from './interest'

export default (
  prefixActionType,
  config = {
    // This means items collection is driven by owner, and we have the same
    // item multiple item but \w different owner
    ownerDriven: false,

    // Take care of state obout loading wanted
    handleWanted: true,

    // Handle explicit external items
    handleExt: false,

    // Interest items?
    interest: false,

    // Extend items behaviour
    extendReducers: [],
  }
) => {
  const reducers = [...(config.extendReducers || [])]

  if (config.handleWanted) {
    reducers.push(itemsWantedReducer)
  }

  if (config.interest) {
    reducers.push(itemsInterestReducer)
  }

  // TODO: Check if really needed anymore...
  if (config.handleExt) {
    reducers.push((prevState = { extItems: null }, { type, payload }) => {
      if (type === `${prefixActionType}_SUCCESS`) {
        return {
          ...prevState,
          // Not normalized... beacause are not paginated
          extItems: payload.itemsExt,
        }
      }
    })
  }

  return makeBaseItemsReducer(prefixActionType, {
    reducers,
    ownerDriven: config.ownerDriven,
  })
}



// WEBPACK FOOTER //
// ./src/reducers/items/index.js